import { render } from "./EditarArea.vue?vue&type=template&id=1b3f279b&scoped=true&ts=true"
import script from "./EditarArea.vue?vue&type=script&lang=ts"
export * from "./EditarArea.vue?vue&type=script&lang=ts"

import "./EditarArea.vue?vue&type=style&index=0&id=1b3f279b&scoped=true&lang=css"

import exportComponent from "/home/sensores-test/frontendv2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b3f279b"]])

export default __exports__